import ColumnContainer from './ColumnContainer';
import KanbanBoardHeader from './KanbanBoardHeader';

const KanbanBoard = () => {
  return (
    <div className="mt-8 min-h-screen w-full text-white">
      <KanbanBoardHeader />
      <ColumnContainer />
    </div>
  );
};

export default KanbanBoard;
